export default __webpack_public_path__ + "static/tires-three-ec8e3c675af3610bc21a3ceaecf332c5.svg";